import { render } from "./color.vue?vue&type=template&id=4f69b912&scoped=true"
import script from "./color.vue?vue&type=script&lang=ts"
export * from "./color.vue?vue&type=script&lang=ts"

import "./color.vue?vue&type=style&index=0&id=4f69b912&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f69b912"

export default script